module.exports = __webpack_public_path__ + "img/small-abstract-5.b682716.svg";